const trainingTypesIdsClientCounters: any = {
  2: "counterInd",
  3: "counterInd",
  4: "counterDuo",
  5: "counterDuo",
  6: "counterDuo",
  1: "counterRef",
  7: "counterRef",
  8: "counterRef",
  9: "counterRef",
};

const trainingTypesIdsQuantities: any = {
  2: 10,
  3: 1,
  4: 10,
  5: 1,
  6: 10,
  1: 10,
  7: 8,
  8: 12,
  9: 1,
};

const trainingTypesIdsClientPrices: any = {
  2: "priceInd",
  3: "price1Ind",
  4: "priceDuo",
  5: "price1Duo",
  6: "priceFamilyDuo",
  1: "priceRef",
  7: "priceMat8",
  8: "priceMat12",
  9: "price1Ref",
};

const trainingTypesIdsTrainingTypesForUser: any = {
  2: "Individualni",
  3: "Individualni",
  4: "Duo",
  5: "Duo",
  6: "Duo",
  1: "Grupa",
  7: "Grupa",
  8: "Grupa",
  9: "Grupa",
};

const trainingTypesIdsTrainingTypes: any = {
  2: "Individualni paket",
  3: "1 individualni trening",
  4: "Duo paket",
  5: "1 duo trening",
  6: "Duo porodični paket",
  1: "Grupa",
  7: "Mat paket 8",
  8: "Mat paket 12",
  9: "1 grupni trening",
};

const DataHelper = {
  trainingTypesIdsClientPrices,
  trainingTypesIdsQuantities,
  trainingTypesIdsClientCounters,
  trainingTypesIdsTrainingTypesForUser,
  trainingTypesIdsTrainingTypes,
};

export default DataHelper;
